import React, { useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading";
import { renderPrice } from "../../Utils/functions";
import { useListAds } from "./Hooks";

const ListAds = () => {
  const { data, loading, searchParams, navigate, renderstatus, getNext, nextLoading } = useListAds();

  return (
    <div>
      <header className="d-flex justify-content-between mb-3">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">آگهی های من</p>
        </div>
      </header>
      <div className="container">
        <div className="row">
          {loading ? (
            <>
              <Loading count={3} />
            </>
          ) : (
            <>
              {data?.data?.map((item, count) => {
                return (
                  <div key={count} className="col-12">
                    <div className="vertical-card">
                      <div className="image-card">
                        <img src={item?.main_image?.url} />
                      </div>
                      <div className="content-vertical-card">
                        <h6>{item.title}</h6>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="price-card">{`وضعیت آگهی :`}</p>
                          <p style={{ fontSize: "12px" }}>{`${renderstatus(item.status)["title"]
                            }`}</p>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <button
                            onClick={() => {
                              navigate(`/my-ads/${item.id}`);
                            }}
                            className="btn btn-primary"
                            style={{ fontSize: "10px", padding: "2px 8px" }}
                          >
                            مدیریت آگهی
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {data.next_page_url &&
                <div className="col-12">
                  <button
                    className="btn btn-primary mb-4 mt-3 w-100"
                    onClick={() => getNext(data.next_page_url)}>
                    {nextLoading ? "در حال دریافت" : "نمایش بیشتر"}
                  </button>
                </div>
              }
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListAds;
